// Admin Login Actions
export const ADMIN_LOGIN_REQUEST = 'ADMIN_LOGIN_REQUEST';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAILURE = 'ADMIN_LOGIN_FAILURE';

// MFA Actions
export const VERIFY_MFA_REQUEST = 'VERIFY_MFA_REQUEST';
export const VERIFY_MFA_SUCCESS = 'VERIFY_MFA_SUCCESS';
export const VERIFY_MFA_FAILURE = 'VERIFY_MFA_FAILURE';

export const RESET_MFA_REQUEST = 'RESET_MFA_REQUEST';
export const RESET_MFA_SUCCESS = 'RESET_MFA_SUCCESS';
export const RESET_MFA_FAILURE = 'RESET_MFA_FAILURE';

// Reset MFA Token Actions
export const RESET_MFA_TOKEN_REQUEST = 'RESET_MFA_TOKEN_REQUEST';
export const RESET_MFA_TOKEN_SUCCESS = 'RESET_MFA_TOKEN_SUCCESS';
export const RESET_MFA_TOKEN_FAILURE = 'RESET_MFA_TOKEN_FAILURE';

// Secure QR Code Actions
export const SECURE_QR_REQUEST = 'SECURE_QR_REQUEST';
export const SECURE_QR_SUCCESS = 'SECURE_QR_SUCCESS';
export const SECURE_QR_FAILURE = 'SECURE_QR_FAILURE';

// Reset Password Actions
export const ADMIN_RESET_PASSWORD_REQUEST = 'ADMIN_RESET_PASSWORD_REQUEST';
export const ADMIN_RESET_PASSWORD_SUCCESS = 'ADMIN_RESET_PASSWORD_SUCCESS';
export const ADMIN_RESET_PASSWORD_FAILURE = 'ADMIN_RESET_PASSWORD_FAILURE';

// Logout Action
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';

// Action Creators
export const adminLoginRequest = (email, password) => ({
    type: ADMIN_LOGIN_REQUEST,
    payload: { email, password },
});

export const verifyMfaRequest = (mfaCode, sessionId) => ({
    type: VERIFY_MFA_REQUEST,
    payload: { mfa_code: mfaCode, session_id: sessionId },
});

export const resetMfaRequest = (sessionId) => ({
    type: RESET_MFA_REQUEST,
    payload: { session_id: sessionId },
});

export const resetMfaTokenRequest = (email) => ({
    type: RESET_MFA_TOKEN_REQUEST,
    payload: { email },
});

export const secureQRRequest = (token, email) => ({
    type: SECURE_QR_REQUEST,
    payload: { token, email },
});

export const adminResetPasswordRequest = (email) => ({
    type: ADMIN_RESET_PASSWORD_REQUEST,
    payload: { email },
});

export const clearAdminAuthError = () => ({
    type: 'CLEAR_ADMIN_AUTH_ERROR',
});

export const clearResetMfaToken = () => ({
    type: 'CLEAR_RESET_MFA_TOKEN',
});

export const clearSecureQR = () => ({
    type: 'CLEAR_SECURE_QR',
});

export const logout = () => ({
    type: ADMIN_LOGOUT,
});

